import React from "react";
import NavbarMenu from "../heroSection/NavbarMenu";
import LoginForm from "../login/LoginForm";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import SEO from "../SEO";

export default function LoginPage() {
  const { t } = useTranslation();
  return (
    <>
      <SEO
        title="TransCirox – Anmelden | Login für Ihr Konto"
        description="Melden Sie sich bei Ihrem TransCirox-Konto an und verwalten Sie Ihre Transporte und Buchungen."
        keywords="TransCirox Login, Anmelden, Konto"
      />
      <NavbarMenu />

      <LoginForm />

      <Footer />
    </>
  );
}
